import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import type { IAffiliateWebhooksHistoryListItem } from '@modules/webhooks-history/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import {
  WEBHOOKS_HISTORY_PERMISSIONS,
} from '@modules/webhooks-history/constants';
import {
  WEBHOOKS_DETAILS_QUERY_KEY,
  WEBHOOKS_HISTORY_DETAILS_API_URL,
} from '@modules/webhooks-history/submodules/history-details/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function useWebhooksHistoryDetailsQuery(
  tableState: Ref<ITableState>,
  id: Ref<number | undefined>,
): IContextQueryResult<
    ITableDataResponse<IAffiliateWebhooksHistoryListItem>,
    Error
  > {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliateWebhooksHistoryListItem>>({
    queryKey: [WEBHOOKS_DETAILS_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliateWebhooksHistoryListItem>>(
      WEBHOOKS_HISTORY_DETAILS_API_URL,
      tableState.value,
      {
        signal,
        permission: WEBHOOKS_HISTORY_PERMISSIONS.SHOW,
        urlParams: {
          id: id.value,
        },
      },
    ),
    placeholderData: keepPreviousData,
  });
}
